import { IPlansService } from "../domain/interfaces/IPlansService";
import { IPlans } from "../presentation/interfaces/IPlans";

export const GetPlansUseCase = async (service: IPlansService, categoryId?: number): Promise<IPlans[]> => {
    return service.getPlans(categoryId);
}
